export default __webpack_public_path__ + "static/media/komatsu-astra-finnance.d7ce3be7.svg";